import React from 'react';
import { Button } from 'native-base';
import { IS_SMALLER_DEVICE } from '../../../Constants';
import { useDomParser } from '../../../../components/hooks/useDomParser';
const PostModalFooter = ({
  id,
  key,
  selectedPostCategoryId,
  data,
  handlePost,
  setShowModal,
  isValid,
  onCloseHandler
}) => {
  const {
    getParser,
    submitAtMentions
  } = useDomParser();
  const substituteBeforePost = async data => {
    // parse/normalize markup
    let sourceHTML = data.raw;
    const parser = getParser();
    if (parser) {
      sourceHTML = submitAtMentions(parser, sourceHTML);
    }
    data.raw = sourceHTML;
    handlePost(data);
    onCloseHandler && onCloseHandler();
  };

  // attach category to new topic data
  if (id === 'newTopic' || key === 'newTopic') {
    data.category = selectedPostCategoryId;
  }
  return /*#__PURE__*/React.createElement(Button.Group, {
    alignSelf: "flex-end",
    position: "fixed",
    bottom: IS_SMALLER_DEVICE ? '2vh' : '1vh',
    right: IS_SMALLER_DEVICE ? '2vw' : '1vw'
  }, /*#__PURE__*/React.createElement(Button, {
    variant: 'ghost',
    colorScheme: 'blueGray',
    onPress: () => setShowModal && setShowModal(false)
  }, "Cancel"), /*#__PURE__*/React.createElement(Button, {
    onPress: async () => {
      if (!isValid) {
        throw new Error('Invalid data. Aborting the request');
      } else {
        await substituteBeforePost(data);
        setShowModal && setShowModal(false);
      }
    },
    isDisabled: !isValid
  }, id === 'edit' || key === 'edit' ? 'Update' : 'Post'));
};
export default PostModalFooter;
//# sourceMappingURL=PostModalFooter.js.map